import { userResourcesLanguageEnglish } from '../userResources';

import type { RolesTranslationMessages } from './rolesTranslationMessages';

export const rolesLanguageEnglish: RolesTranslationMessages = {
  roles: {
    ...userResourcesLanguageEnglish.groups,
    name: 'Roles',
    description:
      'By selecting the role, all permissions will be generated automatically. You can still modify them later.',
    fields: {
      ...userResourcesLanguageEnglish.groups.fields,
      name: 'Role name',
    },
    operations: {
      ...userResourcesLanguageEnglish.groups.operations,
      create: 'Create role',
      delete: 'Delete the role',
      edit: 'Edit role',
      sections: {
        ...userResourcesLanguageEnglish.groups.operations.sections,
        groupsInfo: 'Role info',
      },
    },
    helperTexts: {
      acl_labels: 'List of access labels for this role',
    },
    names: {
      admin: {
        name: 'Admin',
        description: 'All permission over all resources',
      },
      userManager: {
        name: 'User Manager',
        description: 'Manages users and all related resources',
      },
      queueManager: {
        name: 'Queue Manager',
        description: 'Manages queues and all related resources',
      },
      flowManager: {
        name: 'Flow Manager',
        description: 'Manages dialplans and all related resources',
      },
      supervisor: {
        name: 'Supervisor',
        description: 'Can see CDRs and recordings',
      },
      opSupervisor: {
        name: 'OP Supervisor',
        description: 'Full visibility and management of the Operator Panel',
      },
    },
  },
};
